import { USERABLE_TYPE } from 'domains/fast-sell-price-offer/constants'
import * as Yup from 'yup'

const fastSellPriceOfferFormSchema = Yup.object().shape({
  price_offers: Yup.array()
    .of(
      Yup.object().shape({
        price: Yup.number()
          .required('Required')
          .moreThan(0, 'Must be more than 0.'),
        user: Yup.object().shape({
          user_type: Yup.string()
            .required('Required')
            .oneOf(
              [ USERABLE_TYPE.SELLER, USERABLE_TYPE.ADMIN ],
              'Must be seller or admin.'
            )
        })
      })
    )
})

export default fastSellPriceOfferFormSchema
